import React, { ComponentProps } from 'react';
import 'react-circular-progressbar/dist/styles.css';
import { useSelector } from 'react-redux';
import { ReducerState } from '../../services/common/lib/reducerState';
import AvatarRender from './AvatarRender';
import { AvatarProps } from './avatar.types';
import AvatarImage from './AvatarImage';
import useGetAvaturnUser from '../../services/avaturn/queries/useGetAvaturnUser';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import AvatarPlaceholder from './AvatarPlaceholder';

const Avatar = ({ userId, className, border = false, round = true, avatar2D }: AvatarProps) => {
  const are3DModelsEnabled = useSelector((state: ReducerState) => !!state.auth.settings?.modelsEnabled);

  const { data: user, isLoading, isError: isUserAvatarError } = useGetAvaturnUser({ userId });

  if (isLoading) return <LoadingSpinner size="12" />;

  if (isUserAvatarError || !user?.data)
    return <AvatarPlaceholder className={className} round={round} userId={userId} />;

  if (avatar2D || (!are3DModelsEnabled && user.data.imageUrl)) {
    return <AvatarImage userId={userId} className={className} round={round} border={border} avaturnUser={user.data} />;
  }

  if (are3DModelsEnabled && user.data.modelUrl && !avatar2D) {
    return <AvatarRender userId={userId} className={className} round={round} border={border} avaturnUser={user.data} />;
  }

  return <AvatarPlaceholder className={className} round={round} userId={userId} />;
};

export default Avatar;
